import { render, staticRenderFns } from "./PetEvent.vue?vue&type=template&id=7f6c5478&scoped=true"
import script from "./PetEvent.vue?vue&type=script&lang=js"
export * from "./PetEvent.vue?vue&type=script&lang=js"
import style0 from "./PetEvent.vue?vue&type=style&index=0&id=7f6c5478&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6c5478",
  null
  
)

export default component.exports